module.exports = __webpack_public_path__ + "img/place-white.675e12b6.svg";